module.exports = __webpack_public_path__ + "img/user_lz_lx_selected.b78d1333.png";